<template>
  <transition name="fade">
    <div v-if="toggleModal" class="tw-fixed tw-z-[100] tw-inset-0 tw-overflow-y-auto">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-pt-4 tw-px-4 tw-pb-20 tw-text-center sm:tw-px-4">
        <div style="z-index: -1;" class="tw-fixed tw-inset-0 tw-transition-opacity">
          <div class="tw-absolute tw-inset-0 tw-bg-jrGray-60 tw-opacity-75"></div>
        </div>

        <div
          class="tw-inline-block tw-bg-jrGray-50 tw-rounded-lg tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-my-8 tw-w-full lg:tw-w-3/4"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">

          <div class="tw-w-full tw-p-8 tw-text-left">
            <div class="tw-flex tw-flex-col tw-font-new">
              <span class="tw-uppercase tw-font-bold tw-text-xl tw-leading-tight">Condições de Venda</span>
              <p>Leilão #{{ leilao.id }}</p>
              <p><span class="tw-font-semibold">Local: </span>{{ leilao.nm_local }}</p>
              <p><span class="tw-font-semibold">Horário: </span>{{ this.getDataVigente() }}</p>

              <div class="tw-mt-4 tw-p-3 tw-bg-white tw-rounded-lg tw-text-xs">
                <div
                  v-if="leilao.nm_descricao"
                  v-html="leilao.nm_descricao"
                  class="tw-w-full tw-mt-4 tw-rounded-lg focus:tw-outline-none tw-overflow-y-scroll tw-h-72"></div>
                <div class="tw-mt-2" v-else>Aguardando cadastro das informações do leilão.</div>
              </div>

            </div>
          </div>

          <div class="tw-flex tw-justify-center tw-p-6">
            <div class="tw-flex tw-px-3 tw-pt-2 tw-pb-2">
              <button
                @click="modalToggle"
                class="tw-bg-jrGray-300 tw-text-white tw-px-4 tw-py-1 tw-rounded-md">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Informacoes",
  props: ['leilao'],
  data() {
    return {
      toggleModal: false,
      content: null
    }
  },
  methods: {
    modalToggle() {
      this.toggleModal = !this.toggleModal
    },
    getDataVigente() {
      const dataAtual = new Date()
      const primeiroLeilao = new Date(`${this.leilao.dt_formatada.split('/')[2]}-${this.leilao.dt_formatada.split('/')[1]}-${this.leilao.dt_formatada.split('/')[0]} ${this.leilao.hr_formatada}`)
      const segundoLeilao = this.leilao.dt_segundoleilao_data ? new Date(`${this.leilao.dt_segundoleilao_data.split('/')[2]}-${this.leilao.dt_segundoleilao_data.split('/')[1]}-${this.leilao.dt_segundoleilao_data.split('/')[0]} ${this.leilao.dt_segundoleilao_hora}`) : null

      return dataAtual > primeiroLeilao ? (segundoLeilao ? segundoLeilao.toLocaleString() : primeiroLeilao.toLocaleString()) : primeiroLeilao.toLocaleString();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Informacoes.vue